import * as React from 'react';
import { SVGProps, Ref, forwardRef } from 'react';
const SvgGroupColumns = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M.5 3.5h3m3 0h9m-9 3h2m3 0h4m-9 3h2m3 0h4m-9 3h2m3 0h4"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgGroupColumns);
export default ForwardRef;
